import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createReducer } from './reducers';
export let store;
/**
 * https://stackoverflow.com/questions/32968016/
 * https://tylergaw.com/articles/dynamic-redux-reducers/
 */
export const initializeStore = (initialState) => {
    store = createStore(createReducer(), initialState, applyMiddleware(thunk));
    store.asyncReducers = {};
    return store;
};
export const injectAsyncReducer = (name, asyncReducer) => {
    if (store.asyncReducers[name]) {
        return;
    }
    store.asyncReducers[name] = asyncReducer;
    store.replaceReducer(createReducer(store.asyncReducers));
};
//# sourceMappingURL=store.js.map